<template>
  <v-menu offset-y>
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-bind="attrs" v-on="on" :class="btnClass" :disabled="disabled">
        {{ title }}<v-icon right>mdi-share</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="item in availableFormats"
        :key="item.name"
        link
        @click="onClick(item)"
      >
        <v-list-item-icon>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "report-share-menu",
  props: {
    formats: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => "Share Report",
    },
    btnClass: {
      type: String,
      default: () => "ma-1",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      items: [
        {
          name: "PDF",
          value: "pdf",
          icon: "mdi-pdf-box",
        },
        {
          name: "HTML",
          value: "html",
          icon: "mdi-language-html5",
        },
        {
          name: "CSV",
          value: "csv",
          icon: "mdi-file-delimited",
        },
        {
          name: "XLSX",
          value: "xlsx",
          icon: "mdi-file-excel",
        },
      ],
    };
  },

  computed: {
    availableFormats() {
      return this.items.filter((item) => this.formats.includes(item.name));
    },
  },
  methods: {
    onClick(item) {
      this.$emit("click", item);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/reports/ReportShareMenu.vue